import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  errorPostGroupOrders: null,
  postGroupOrdersResponse: null,
  isProcessingPostGroupOrders: false,
  errorPostBulkDayJob: null,
  postBulkDayJobResponse: null,
  isProcessingPostBulkDayJob: false,
};

export const jobCreateSlice = createSlice({
  name: 'jobCreateSlice',
  initialState,
  reducers: {
    /* eslint-disable no-param-reassign */
    postGroupOrders: (state) => {
      state.isProcessingPostGroupOrders = true;
    },
    postGroupOrdersProcessed: (state, action) => {
      state.isProcessingPostGroupOrders = false;
      state.postGroupOrdersResponse = action.payload;
    },
    postGroupOrdersError: (state, action) => {
      state.isProcessingPostGroupOrders = false;
      const errors = action?.payload?.errors?.GLOBAL?.errors;
      const messageData =
        (errors && errors[0] && errors[0].messageKey) ||
        action?.payload?.errors?.GLOBAL?.messageKey ||
        'error.generic.something.went.wrong';
      state.errorPostGroupOrders = messageData;
    },
    clearGroupError: (state) => {
      state.errorPostGroupOrders = null;
    },
    clearPostGroupOrdersResponse: (state) => {
      state.postGroupOrdersResponse = null;
    },
    postBulkDayJob: (state) => {
      state.isProcessingPostBulkDayJob = true;
    },
    postBulkDayJobProcessed: (state, action) => {
      state.isProcessingPostBulkDayJob = false;
      state.postBulkDayJobResponse = action.payload;
    },
    postBulkDayJobError: (state, action) => {
      state.isProcessingPostBulkDayJob = false;
      const errors = action?.payload?.errors?.GLOBAL?.errors;
      const messageData =
        (errors && errors[0] && errors[0].messageKey) ||
        action?.payload?.errors?.GLOBAL?.messageKey ||
        'error.generic.something.went.wrong';
      state.errorPostBulkDayJob = messageData;
    },
    clearBulkDayJobError: (state) => {
      state.errorPostBulkDayJob = null;
    },
    clearPostBulkDayJobResponse: (state) => {
      state.postBulkDayJobResponse = null;
    },
  },
});

export const jobCreateReducer = jobCreateSlice.reducer;

export const {
  postGroupOrders,
  postGroupOrdersProcessed,
  postGroupOrdersError,
  clearGroupError,
  clearPostGroupOrdersResponse,
  postBulkDayJob,
  postBulkDayJobProcessed,
  postBulkDayJobError,
  clearBulkDayJobError,
  clearPostBulkDayJobResponse,
} = jobCreateSlice.actions;
